import Service from '../abstract/service'
import Functions from '@/utils/functions'

export default class Empresa extends Service {
  constructor() {
    super()

    this._empresaRef = this._db.collection(
      `${this._prefix}-gruposEmpresas/${this._grupoPrincipal}/Empresas`
    )
    this._dataSyncRef = this._db.collection(
      `${this._prefix}-gruposEmpresas/${this._grupoPrincipal}/DataSync`
    )
  }
  //TODO IMPLEMENTAR FUNÇÃO
  /* Lista todas empresas */
  async getAll() {
    try {
      const response = await this._empresaRef.get()

      let empresas = new Array()
      if (!response.empty) {
        for (let doc of response.docs) {
          let empresa = doc.data()
          if (empresa.ativo) {
            empresas.push(empresa)
          }
        }
      }

      return Promise.resolve(empresas)
    } catch (error) {
      return Promise.reject(error)
    }
  }

  /* Lista todas empresas */
  async listAll(params) {
    try {
      this._loading.setLoading(true, 'Carregando Informações')
      let ativo = false
      if (params.ativo === 'Sim') {
        ativo = true
      }
      const response = await this._empresaRef
        .where('ativo', '==', ativo)
        .where('seguimento', '==', params.segmento)
        .get()

      let empresas = new Array()
      if (!response.empty) {
        for (let doc of response.docs) {
          let empresa = doc.data()
          empresas.push(empresa)
        }
      }

      return Promise.resolve(empresas)
    } catch (error) {
      return Promise.reject(error)
    } finally {
      this._loading.setLoading(false)
    }
  }

  async getByFabricante(fabricante) {
    try {
      this._loading.setLoading(true, 'Carregando Empresas')
      let empresas = new Array()

      const response = await this._empresaRef
        .where('fabricante', '==', fabricante)
        .get()

      if (!response.empty) {
        for (let doc of response.docs) {
          empresas.push({
            id: doc.id,
            ...doc.data()
          })
        }
      }
      return Promise.resolve(empresas)
    } catch (error) {
      return Promise.reject(error)
    } finally {
      this._loading.setLoading(false)
    }
  }

  async getByCnpj(cnpj_empresas) {
    try {
      this._loading.setLoading(true, 'Carregando Empresas')

      const groupsEmresas = Functions.dividirArray(cnpj_empresas, 10)

      let empresas = new Array()
      for (const group of groupsEmresas) {
        const response = await this._empresaRef
          .where('cnpj', 'in', group)
          .get()

        if (!response.empty) {
          for (let doc of response.docs) {
            empresas.push({
              id: doc.id,
              ...doc.data()
            })
          }
        }
      }
      return Promise.resolve(empresas)
    } catch (error) {
      return Promise.reject(error)
    } finally {
      this._loading.setLoading(false)
    }
  }

  async insertEmpresa(params) {
    try {
      const response = await this._empresaRef.doc(params.cnpj).set(params)
      return Promise.resolve(response)
    } catch (error) {
      console.error(error)
      return Promise.reject(error)
    }
  }
  async selectionEmpresa(numero) {
    try {
      // let isCadastrado = false;
      let response = await this._empresaRef.where('cnpj', '==', numero).get()
      // if (!response.empty) {
      //   isCadastrado = true;
      // }
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  }

  async desativaSincronizacaoAntiga() {
    try {
      const response = await this._dataSyncRef.where('ativo', '==', true)
        .where('descricao', '==', 'Empresa')
        .get()
      if (!response.empty) {
        const [doc] = response.docs
        const sincAntiga = await this._dataSyncRef.doc(doc.id)
        await sincAntiga.update({ ativo: false })
      }
      return Promise.resolve()
    } catch (error) {
      return Promise.reject(error)
    }
  }

  async criaSincronizacao(empresas) {
    try {
      this._loading.setLoading(true, 'Gerando Sincronização')

      await this.desativaSincronizacaoAntiga()
      await this._dataSyncRef.doc().set({
        ativo: true,
        dataCriacao: new Date(),
        descricao: 'Empresa',
        empresas
      })
      return Promise.resolve()
    } catch (error) {
      return Promise.reject(error)
    } finally {
      this._loading.setLoading(false)
    }
  }

  async updateEmpresa(params) {
    try {
      this._loading.setLoading(true, 'Atualizando Empresa')
      const response = await this._empresaRef.doc(params.cnpj).update(params)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    } finally {
      this._loading.setLoading(false)
    }
  }

  async updateAtivo(id, value) {
    try {
      this._loading.setLoading(true, 'Atualizando Estado da Empresa')
      const response = await this._empresaRef.doc(id).update({ ativo: value })
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    } finally {
      this._loading.setLoading(false)
    }
  }
}
